import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import Notifications from 'vue-notification';
import VueSession from 'vue-session';
import Vuelidate from 'vuelidate';
import VTooltip from 'v-tooltip';
import WOW from 'wow.js';
import router from './router';
import store from './store';
import UnsupportBrowsers from './UnsupportBrowsers.vue';
import App from './App.vue';

import 'swiper/dist/css/swiper.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'animate.css/animate.min.css';

Vue.use(VueSession);
Vue.use(VueAwesomeSwiper);
Vue.use(VTooltip);
Vue.use(Vuelidate);
Vue.use(Notifications);
Vue.config.productionTip = false;

// Internet Explorer 6-11
const isIE = false || !!document.documentMode;
// Edge 20+
const isEdge = !isIE && !!window.StyleMedia;
if (!isIE && !isEdge) {
  new Vue({
    router,
    store,
    render: h => h(App),
    methods: {
      onBodyScroll() {
        document.body.classList.remove('modal-open');
      },
      offBodyScroll() {
        document.body.classList.add('modal-open');
      },
    },
    mounted() {
      new WOW().init();
    },
  }).$mount('#app');
} else {
  new Vue({
    render: h => h(UnsupportBrowsers),
    methods: {
    },
    mounted() {
    },
  }).$mount('#app');
}
